import styled from '@emotion/styled';
import { shouldForwardProps } from '../../helpers';

const Icon = ({ icon: renderIcon, onClick, color, ...props }) => {
  const { customPropsObj } = shouldForwardProps(props);
  const IconButton = styled('button')({ border: 0, backgroundColor: 'transparent', padding: 0, ...customPropsObj });

  return (
    <IconButton as={`${onClick ? 'button' : 'div'}`} disabled={onClick ? false : null} onClick={onClick}>
      {renderIcon(color)}
    </IconButton>
  );
};

export default Icon;
